module.exports = __webpack_public_path__ + "99a59a44d55e11a0b74fec97201b6761.fbx";